// extracted by mini-css-extract-plugin
export default {"link":"ButtonLink_link__6eBwS"};